<div class="carousel">
  <ng-container *ngTemplateOutlet="header"></ng-container>
  <div class="content" [class.scrollable]="this.dotsAmount > 1" #scroller>
    <ng-container *ngTemplateOutlet="scrollable"></ng-container>
  </div>
  <ul class="dots" *ngIf="dots.length > 1">
    <li *ngFor="let item of dots; let index = index" (click)="scrollToIndex(index)" class="dot" [class.active]="index === activeTableIndex"></li>
  </ul>
</div>
